/********************************************************************
 * jquery.js
 * Accessing jQuery from outside of Webpack JavaScript Files.
 */

// create global $ and jQuery variables

import $ from 'jquery';

window.jQuery = $;
window.$ = $;
jQuery = $;

// create global $ and jQuery variables
if (global === undefined) {
  var global = window;
}
global.$ = global.jQuery = $;
